import React, { createContext, ReactNode, useContext, useState } from 'react';
import { UserRole } from '~/constants';
import { User } from '~/types/user';

interface UserContextParams {
  loggedInUser: User
  setLoggedInUser: React.Dispatch<React.SetStateAction<User>>
}

const UserContext = createContext({} as UserContextParams);

const UserContextProvider = ({children}: {children?: ReactNode}) => {
  const [loggedInUser, setLoggedInUser] = useState({} as User);

  switch (loggedInUser?.role?.code) {
    case UserRole.ADMIN:
      loggedInUser.isAdmin = true;
      break;
    case UserRole.INVESTOR:
      loggedInUser.isInvestor = true;
      break;
    case UserRole.INSTALLER:
      loggedInUser.isInstaller = true;
      break;
    case UserRole.EXTERNAL:
      loggedInUser.isExternalCompany = true;
      break;
  }

  return (
    <UserContext.Provider
      value={{
        loggedInUser,
        setLoggedInUser,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserContextProvider;

export const useUserContext = () => useContext(UserContext);
